"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import { AbExperiment, getOrAssignExperimentVariant } from "@/utils/abTesting";
import { trackEvent } from "@/utils/analytics";

function getExposureSessionKey(experimentId: string, variant: string, path: string) {
  return `sr_ab_exposed:${experimentId}:${variant}:${path}`;
}

export function useAbExperiment(experiment: AbExperiment) {
  const path = usePathname();
  const [variant, setVariant] = useState(experiment.variants[0]?.key ?? "control");
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const assignedVariant = getOrAssignExperimentVariant(experiment);
    setVariant(assignedVariant);
    setIsReady(true);

    const exposureSessionKey = getExposureSessionKey(experiment.id, assignedVariant, path);
    if (sessionStorage.getItem(exposureSessionKey)) return;

    sessionStorage.setItem(exposureSessionKey, "1");
    trackEvent("ab_exposed", path, {
      experiment_id: experiment.id,
      variant: assignedVariant,
      page_location: window.location.pathname,
    });
  }, [experiment, path]);

  return { variant, isReady };
}
